import React, { useState } from "react";
import { GrFormSubtract, GrAdd } from "react-icons/gr";
const FAQ = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="Accordion__container"
      style={{ borderRadius: "6px", border: "1px solid rgba(0,0,0,.1)" }}
    >
      <div className="Accordion__container__heading">
        <div>
          <p style={{ fontSize: "16px" }}>{question}</p>
        </div>

        {open ? (
          <GrFormSubtract
            size={18}
            style={{ cursor: "pointer" }}
            onClick={() => setOpen(!open)}
          />
        ) : (
          <GrAdd
            size={18}
            style={{ cursor: "pointer" }}
            onClick={() => setOpen(!open)}
          />
        )}
      </div>
      {open ? <p style={{ marginTop: "20px" }}>{answer}</p> : <></>}
    </div>
  );
};

export default FAQ;
